/*

Filter-Dropdown

(!) Das hier ist NUR das Dropdown. Kein Label, keine Abstände, nix.

Abstraktion von sal-filter-select.vue vom ProduktFinder nur ohne harter Bindung an den Store.
Außerdem leicht abweichende Funktion.

ProduktFinder: Label im Dropdown; Ausgewähltes Element mit Checkbox.
Global Filter-Dropdown: näher am HTML <select />. Ausgewähltes Element steht im Dropdown. Label nicht enthalten.

Parameters:
 - options: Object[] > Required properties: key(unique), title; Other properties: style=title/nested, disabled, selected(with multiSelect),
 - selectedOption: The selected option (=== one of the options) (If multiselect is used, set the property selected of the option)
 - initialTitle: string > The title which is shown in the dropdown. After a selection the title changes to the selected title.
 - disabled: bool > whether the control is disabled
 - hasError: bool > whether or not mark the drodown as errorneaous
 - multiSelect: bool (false) > If set the dropdown will always display the initialTitle instead of the selected option. No-Touch-Variant is not supported.
 - theme: string > The theme to use. Currently only supporting 'secondary'

Events:
 - change: When something is selected. Returns the selected object as payload.

*/
<template>
    <div class="global-dropdown__wrapper">
        <div class="global-dropdown global-dropdown--native">
            <div class="global-dropdown__head" :class="[iconClass, themeClass]">
                <select v-model="nativeSelection" :class="{'disabled': disabled, 'has-error': hasError}" :disabled="disabled">
                    <option value="" disabled>{{initialTitle}}</option>
                    <template v-for="(option, index) in options">
                            <option :key="index" :value="option" :disabled="option.disabled" v-html="nativeOptionTitle(option)"></option>
                    </template>
                </select>
            </div>
        </div>
        <div class="global-dropdown global-dropdown--styled" :class="[isOpen ? 'global-dropdown--open' : '']">
            <div class="global-dropdown__head" :class="[disabled ? 'disabled': '', hasError ? 'has-error' : '' , iconClass, themeClass]" @click="toggleFilter()" v-html="displayedTitle" />
            <div class="global-dropdown__body" v-show="isOpen" :class="themeClass">
                <ul class="global-dropdown__list">
                    <template v-for="(option, index) in options">
                        <li :key="index" class="global-dropdown__option" :class="{selected: isSelected(option), disabled: option.disabled, 'global-dropdown__option--group': option.style === 'group', 'global-dropdown__option--nested': option.style === 'nested'}" @click="handleOptionClick(option)" v-html="option.title"></li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            isOpen: false,
            selectedValue: this.selectedOption
        }
    },
    name: "global-dropdown",
    props: {
        options: Array,
        selectedOption: Object,
        initialTitle: String,
        disabled: Boolean,
        hasError: {
            type: Boolean,
            default: false
        },
        multiSelect: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: 'secondary',
            validator(value) {
                return ['secondary', 'sustainable'].indexOf(value) !== -1;
            }
        }
    },
    watch: {
        options: function() {
            this.selectedValue = null;
        }
    },
    computed: {
        nativeSelection: {
            get() {
                return this.selectedValue || '';
            },
            set(value, oldValue) {
                if (value) {
                    this.handleOptionClick(value);
                }
            }
        },
        isFilterOpen: function() {
            return this.isOpen && !this.disabled;
        },
        displayedTitle: function() {
            return !this.multiSelect && this.selectedValue != null ? this.selectedValue.title : this.initialTitle;
        },
        themeClass: function() {
            return (this.theme ? 'global-dropdown--' + this.theme : '')
        },
        iconClass: function() {
            return 'icon--after icon--absolute ' + (this.isOpen ? 'icon--arrow-up' : 'icon--arrow-down');
        }
    },
    methods: {
        toggleFilter() {
            if (!this.disabled) {
                this.isOpen = !this.isOpen;
            }
        },

        closeFilter() {
            this.isOpen = false;
        },

        isSelected(option) {
            return this.multiSelect ? option.selected : (this.selectedValue != null && this.selectedValue.key === option.key);
        },

        handleOptionClick(option) {
            if (option.disabled) {
                return false;
            }

            if (!this.disabled) {
                if (!this.multiSelect) {
                    this.selectedValue = option;
                }
                this.$emit('change', option);
            }

            this.closeFilter();
        },
        nativeOptionTitle(option) {
            let title = option.title;

            if (this.multiSelect && option.selected) {
                title = '✓ ' + title;
            }

            if (option.style === 'nested') {
                title = ' - ' + title;
            }

            return title;
        }
    },
    created() {
        document.addEventListener('click', event => {
            if (!this.$el.contains(event.target)) {
                this.closeFilter();
            }
        });
    }
}
</script>
